// extracted by mini-css-extract-plugin
export default {"content":"content__jI0DysO4","header":"header__uvUQ27YC","body":"body__hF5DCHPr","footer":"footer__B3bEsQfe","title":"title__AgLuVnIv","centered":"centered__Ycg4QGob"};